module.exports = __webpack_public_path__ + "img/rob_outdoor.06bc754c.png";